export { 
  daysIndex,
  MONTHS,
  WEEK_DAYS,
} from './dates';

export {
  getSystemsError,
  adminEmailsError,
  projectEntriesError,
  getLrProjectsError,
  getLrProceduresError,
  addLrProjectError,
  addVpinProjectError,
  addTimeEntryBulkError,
  getBulkTimeEntryTimeLimitError,
} from './toastrErrorMsg';

export const SupportedSystems = {
  ADMIN: 'ADMIN',
  LRS: 'LRS',
  GPRS: 'GPRS',
  VPIN: 'VPIN',
};

export const Routes = {
  LRS: '/lrs',
  GPRS: '/gprs',
  VPIN: '/engineering',
  REPORTS: '/reports',
  PREFERENCES: '/preferences',
  DIRECTREPORTS: '/directReports'
};

export const EMPTY_ARRAY = [];

export const HoursLimit = 15;